import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import styled from 'styled-components';

const AccessDeniedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: ${({ theme }) => theme.spacing[80]};
  text-align: center;
`;

const AccessDeniedTitle = styled.h1`
  color: ${({ theme }) => theme.palette.danger.default};
  font-size: ${({ theme }) => theme.typography.heading.size.xl};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin-bottom: ${({ theme }) => theme.spacing[50]};
`;

const AccessDeniedMessage = styled.p`
  color: ${({ theme }) => theme.palette.text.support};
  font-size: ${({ theme }) => theme.typography.body.size.md};
  max-width: 400px;
`;

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin } = useAuth();

  return (
    <ProtectedRoute>
      {isAdmin() ? (
        <>{children}</>
      ) : (
        <AccessDeniedContainer>
          <AccessDeniedTitle>Access Denied</AccessDeniedTitle>
          <AccessDeniedMessage>
            You don't have permission to access this page. Admin privileges are required.
          </AccessDeniedMessage>
        </AccessDeniedContainer>
      )}
    </ProtectedRoute>
  );
};

export default AdminRoute;